export const MAX_STEPS_EDITION = 10;
export const MAX_STEPS_EDITION_LABEL_LENGTH = 20;

let stepsEditionIdCounter = 0;

export const createStepsEditionId = () => {
  stepsEditionIdCounter += 1;
  return `stepsEdition-${Date.now()}-${stepsEditionIdCounter}`;
};

export const normalizeStepsEditionEntry = (entry) => {
  const base = entry && typeof entry === "object" ? entry : {};
  return {
    id: base.id || createStepsEditionId(),
    nodeId: base.nodeId != null ? String(base.nodeId) : "",
    label: String(base.label ?? "").slice(0, MAX_STEPS_EDITION_LABEL_LENGTH),
  };
};

export const normalizeStepsEditionList = (list) => {
  if (!Array.isArray(list)) return [];
  return list
    .map((entry) => normalizeStepsEditionEntry(entry))
    .filter((entry) => entry.nodeId);
};

export const serializeStepsEditionForPayload = (list, idMap) => {
  const normalized = normalizeStepsEditionList(list);
  return normalized
    .filter((entry) => idMap && idMap[entry.nodeId] != null)
    .map((entry, index) => ({
      stepId: idMap[entry.nodeId],
      label: entry.label,
      sortOrder: index,
    }));
};

export const parseApiStepsEdition = (step, uuidToInternal) => {
  const fromApi = Array.isArray(step?.stepsEdition) ? [...step.stepsEdition] : [];
  if (fromApi.length === 0) return [];

  return fromApi
    .sort((a, b) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0))
    .map((item) => {
      const nodeId = uuidToInternal?.[String(item?.stepId)];
      if (!nodeId) return null;
      return normalizeStepsEditionEntry({
        nodeId,
        label: item?.label,
      });
    })
    .filter(Boolean);
};
